import React, { useState, useEffect } from 'react';
import { api } from '../../lib/api';
import PublicProfile from '../../pages/PublicProfile';

export default function DomainGate({ children }) {
  const [resolvedUsername, setResolvedUsername] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isCustomDomain, setIsCustomDomain] = useState(false);

  useEffect(() => {
    const checkDomain = async () => {
      const hostname = window.location.hostname;

      const platformDomains = [
        'localhost',
        'tapbadge.net',
        'tapbadge.app',
        'tapbadge.com',
        'stackblitz.io',
        'webcontainer.io',
        'questera.ai'
      ];

      const isPlatform = platformDomains.some(d => 
        hostname === d || hostname.endsWith('.' + d)
      );

      if (isPlatform) {
        setIsCustomDomain(false);
        setLoading(false);
        return;
      }

      try {
        const { username } = await api.get(`public/domain?host=${encodeURIComponent(hostname)}`);
        if (username) {
          setResolvedUsername(username);
          setIsCustomDomain(true);
        }
      } catch (err) {
        console.error("Domain resolution error:", err);
      } finally {
        setLoading(false);
      }
    };

    checkDomain();
  }, []);

  // Invisible loading state
  if (loading) return null;

  if (isCustomDomain && resolvedUsername) {
    return <PublicProfile forcedUsername={resolvedUsername} />;
  }

  return children;
}
